var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityTalksFocused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab04_filled 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.573 44.2615C10.7494 44.7159 9.79802 45.1561 8.77562 45.5679C6.75922 46.3489 4.33102 46.9879 1.91702 46.9879C1.16442 46.9879 0.482816 46.4625 0.241416 45.7241C1.60933e-05 44.9715 0.269816 44.1479 0.866216 43.6793L0.894616 43.6651C0.923016 43.6509 0.965616 43.6083 1.02242 43.5657C1.12182 43.4805 1.29222 43.3243 1.49102 43.1397C1.88862 42.7705 2.42822 42.2167 2.95362 41.5067C3.56422 40.7115 4.14642 39.7601 4.52982 38.6809C1.77502 35.3439 0.156216 31.2543 0.156216 26.8381C0.156216 15.7053 10.437 6.67407 23.1318 6.67407C35.8266 6.67407 46.1074 15.7053 46.1074 26.8381C46.1074 37.9709 35.8266 46.9879 23.1318 46.9879C18.9144 46.9879 14.9668 45.9939 11.573 44.2615ZM49.5722 25.0489C61.4718 25.8015 70.8438 34.5203 70.8438 45.1561C70.8438 49.5865 69.225 53.6761 66.4702 56.9989C66.8536 58.0639 67.4358 59.0153 68.0464 59.8247C68.5718 60.5347 69.1114 61.0885 69.509 61.4577C69.7078 61.6565 69.8782 61.7985 69.9776 61.8837C70.0344 61.9263 70.077 61.9547 70.1054 61.9689L70.1338 61.9973C70.7444 62.4659 71 63.2895 70.7728 64.0421C70.5314 64.8089 69.8498 65.3201 69.083 65.3201C66.6832 65.3201 64.255 64.6811 62.2244 63.8859C61.2162 63.4883 60.279 63.0339 59.4412 62.5795C56.0474 64.3261 52.0998 65.3201 47.8824 65.3201C37.3176 65.3201 28.4142 59.0721 25.7304 50.5379C38.695 49.3877 49.6432 39.7033 49.6432 26.8381C49.629 26.2275 49.6148 25.6311 49.5722 25.0489Z",
    fill: "#9FD1FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTalksFocused);
export default __webpack_public_path__ + "static/media/activity-talks-focused.22cbbf4d0e378b168eb9e0b7cbf19aac.svg";
export { ForwardRef as ReactComponent };